import React from "react";
import { NavLink } from "react-router-dom";
import { Users, Library } from "lucide-react";

/**
 * Top sub-navigation for the Coaching hub.
 * Two tabs: 1:1 Athletes and Program Library.
 */
export default function CoachingTabs({ className = "" }) {
  const base =
    "inline-flex items-center gap-2 px-4 py-2 text-[11px] tracking-[0.24em] uppercase font-semibold border transition-colors";
  const active =
    "bg-[var(--tir-ink)] text-white border-[var(--tir-ink)]";
  const inactive =
    "bg-white text-[var(--tir-muted)] border-[var(--tir-border)] hover:border-[var(--tir-ink)] hover:text-[var(--tir-ink)]";

  return (
    <div
      className={`flex flex-wrap gap-2 ${className}`}
      data-testid="coaching-tabs"
    >
      <NavLink
        to="/coaching"
        end
        className={({ isActive }) => `${base} ${isActive ? active : inactive}`}
        data-testid="tab-coaching-athletes"
      >
        <Users size={13} />
        1:1 Athletes
      </NavLink>
      <NavLink
        to="/coaching/library"
        className={({ isActive }) => `${base} ${isActive ? active : inactive}`}
        data-testid="tab-coaching-library"
      >
        <Library size={13} />
        Program Library
      </NavLink>
    </div>
  );
}
